var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "-5 -5 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5.625a3.124 3.124 0 1 0-6.25 0c0 1.422.95 2.621 2.246 3-.023.629-.164 1.113-.43 1.441-.601.75-1.925.875-3.328 1.004-1.101.102-2.242.211-3.175.66V6.105A3.123 3.123 0 0 0 5.625 0a3.124 3.124 0 0 0-.938 6.105v7.786A3.132 3.132 0 0 0 2.5 16.875a3.124 3.124 0 1 0 6.25 0 3.12 3.12 0 0 0-2-2.914c.121-.203.305-.383.582-.524.633-.32 1.578-.406 2.582-.5 1.649-.152 3.516-.328 4.617-1.695.547-.68.824-1.555.844-2.652A3.138 3.138 0 0 0 17.5 5.625zM5.625 2.5c.344 0 .625.281.625.625a.627.627 0 0 1-.625.625A.627.627 0 0 1 5 3.125c0-.344.281-.625.625-.625zm0 15A.627.627 0 0 1 5 16.875c0-.344.281-.625.625-.625s.625.281.625.625a.627.627 0 0 1-.625.625zM14.375 5c.344 0 .625.281.625.625a.627.627 0 0 1-.625.625.627.627 0 0 1-.625-.625c0-.344.281-.625.625-.625z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.2a4ffef0ed377a86aedd11c63c99e565.svg";
export { ForwardRef as ReactComponent };